<template>
    <div class="c-land-middle">
        <div class="c-land-middle__tabs">
            <div
                class="c-land-middle__tab is-first"
                :class="{ 'is-active': contentType === 1 }"
                @click="changeContentType(1)"
            >
                地图模式
            </div>
            <div
                class="c-land-middle__tab is-last"
                :class="{ 'is-active': contentType === 2 }"
                @click="changeContentType(2)"
            >
                图册模式
            </div>
        </div>
        <Render :render="renderMap" v-if="contentType == 1" />
        <div class="c-land-middle__picture-content" v-else-if="contentType == 2">
            <PictureContent
                topShowType="always"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :total="total"
                @current-change="getProjectPageList"
                :data="pictureList"
                @pic-card-click="handlePicCardClick"
            >
                <template v-slot:bottom="scope">
                    <div style="line-height: 1.3">
                        <div>
                            {{ scope.data.code }}
                        </div>
                        <div>{{ scope.data.address }}</div>
                    </div>
                </template>
                <template v-slot:top="scope">
                    <div style="padding: 10px">{{ scope.data.name }}</div>
                </template>
            </PictureContent>
        </div>
    </div>
</template>

<script>
import { Render } from '@CommonComponent';

// import globalConfig from '@global';
import PictureContent from '../../components/PictureContent.vue';
import * as Api from '../Api';

export default {
    components: {
        // MainMap,'
        Render,
        PictureContent,
    },
    props: {
        type: {
            // 内容模式，是地图模式还是图册模式
            type: Number,
            default() {
                return 1;
            },
        },
        renderMap: Function,
        landList: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            contentType: this.type,
            page: 1,
            pageSize: 10,
            total: 0,
            pictureList: [],
        };
    },
    methods: {
        changeContentType(val) {
            this.contentType = val;
            this.$emit('changeContentType', val);
        },
        handlePicCardClick(data) {
            this.$router.push({ path: '/jiwei/gongcheng/detail', query: { id: data.id, name: data.name } });
            this.$emit('pic-card-click', data);
        },
        /**
         * 获取图册列表
         */
        getProjectPageList(page) {
            if (this.contentType === 2) {
                // 图册模式时才发请求
                let currentPage = page || 1;
                let params = {
                    page: currentPage,
                    rows: this.pageSize,
                };
                let list = [];
                Api.fetchPageTotal(params)
                    .run()
                    .then((result) => {
                        this.total = result || 0;
                        Api.fetchProjectPicturePageList(params)
                            .run()
                            .then((res) => {
                                list = res || [];
                                list.forEach((item) => {
                                    let pictureList = item.pictureList || [];
                                    if (pictureList[0]) {
                                        // item.url = `${globalConfig.getFileServer()}/${pictureList[0].paths}`;
                                        item.url = `${pictureList[0].fullPath}`;
                                    }
                                });
                                this.pictureList = list;
                            });
                    });
            }
        },
    },
    mounted() {
        this.getProjectPageList();
    },
    watch: {
        type(val) {
            this.contentType = val;

            if (val === 2) {
                this.getProjectPageList();
            }
        },
        landList(val) {
            // console.log(val);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
$picContentTop: 58px;
@include b(land-middle, c) {
    height: 100%;
    width: 100%;
    @include e(tabs) {
        position: absolute;
        top: 16px;
        left: 16px;
        z-index: 1;
        display: inline-block;
        border: 1px solid #1a47a4;
        font-size: 0px;
        @include e(tab) {
            display: inline-block;
            width: 108px;
            height: 34px;
            position: relative;
            z-index: 0;
            font-size: 14px;
            color: white;
            text-align: center;
            line-height: 34px;
            cursor: pointer;
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0px;
                left: 20px;
                width: calc(100% - 20px);
                height: 100%;
                background-color: hsl(238, 91%, 13%);
                z-index: -1;
                transform: skew(-30deg);
            }
            &::before {
                content: '';
                display: block;
                position: absolute;
                top: 0px;
                left: 0px;
                width: calc(100% - 20px);
                height: 100%;
                background-color: hsl(238, 91%, 13%);
                z-index: -1;
                transform: skew(-30deg);
            }
            @include when(first) {
                &::before {
                    transform: skew(0deg);
                }
            }
            @include when(last) {
                &::after {
                    transform: skew(0deg);
                }
            }
            @include when(active) {
                &::after {
                    background-color: hsl(222, 83%, 47%);
                }
                &::before {
                    background-color: hsl(222, 83%, 47%);
                }
            }
            &:hover {
                &::after {
                    background-color: hsl(222, 83%, 47%);
                }
                &::before {
                    background-color: hsl(222, 83%, 47%);
                }
            }
        }
    }
    @include e(picture-content) {
        padding-top: $picContentTop;
        height: calc(100% - #{$picContentTop});
    }
    ::v-deep .c-main {
        bottom: 2px !important;
    }
    ::v-deep .pic-center {
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(7, 17, 80, 0.8);
        padding: 8px;
        font-size: 20px;
    }
}
</style>
